import { useSelector } from "react-redux";
import { useConectividadApi } from "./service";

export const useConveniosService = () => {
    const { serverData } = useConectividadApi();
    const session = useSelector(state => state.session);

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de convenios por el id de un Facturador
   */
    const getByFacturador = async (idFacturador) => {
        try {
            const options = {
                method: 'GET',
                url: `/convenios/facturador/${idFacturador}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }
    /**
* @methodApi post.
* @description  Método encargado de crear convenios
*/
    const post = async (values) => {
        try {
            const options = {
                method: 'POST',
                url: '/convenios',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }

    /**
    * @methodApi v.
    * @description  Método encargado de actualizar convenios
    */
    const put = async (idConvenio, values) => {
        try {
            const options = {
                method: 'PUT',
                url: `/convenios/${idConvenio}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }


    /**
    * @methodApi v.
    * @description  Método encargado de actualizar convenios
    */
    const patch = async (idConvenio, values) => {
        try {
            const options = {
                method: 'PATCH',
                url: `/convenios/${idConvenio}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                },
                data: values
            };
            try {
                await serverData(options);
            } catch (error) {
                let { data } = error;
                alert(data.msg);
            }
        } catch (error) {
            let { data } = error;
            alert(data.msg);
        }
    }

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de convenios por el id de un Facturador
   */
    const getByOficinaAndRecaudador = async (idRecaudador, idOficina) => {
        try {
            const options = {
                method: 'GET',
                url: `convenios/oficinaRecaudador/${idOficina}/${idRecaudador}`,
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de convenios por el id de un Facturador
   */
    const getTiposMoneda = async () => {
        try {
            const options = {
                method: 'GET',
                url: '/convenios/tiposMoneda',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }

    /**
   * @methodApi get.
   * @description  Método encargado de obtener una lista de convenios por el id de un Facturador
   */
    const getTiposConvenio = async () => {
        try {
            const options = {
                method: 'GET',
                url: '/convenios/tiposConvenio',
                headers: {
                    Authorization: `Bearer ${session.credentials.accessToken}`
                }
            };
            return await serverData(options).then(response => {
                let data = response;
                if (data) {
                    return data;
                }
            });
        } catch (err) {
            console.error(err);
        }
    }


    return {
        //Api Convenios
        getByFacturador,
        post,
        put,
        patch,
        getByOficinaAndRecaudador,
        getTiposMoneda,
        getTiposConvenio
    }
}